<mat-toolbar *ngIf="mobile">
  <span class="header">Technik Check</span>
  <button mat-mini-fab mat-dialog-close class="headerClose">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>
<span class="headline" cdkFocusRegionstart>Überprüfen Sie hier Ihre Systemvoraussetzungen // Check System Requirements</span>
<h3 *ngIf="isLoading">Please wait a moment for the check to be completed.</h3>
<span class="valid" *ngIf="!isLoading && !hasProblems">
  Test erfolgreich abgeschlossen, Sie können die Event Plattform nutzen. Vorab können sie unten schon einmal die wichtigsten Module,
  Workshop und Livestream, kennenlernen. <br />
  <br />
  Test completed. Congratulations, your system looks ready for the event. You can get to know the most important features, Workshop and
  Livestream, of our platform below.
</span>

<div class="part-check">
  <mat-icon *ngIf="canUseStreaming == 0">schedule</mat-icon>
  <mat-icon *ngIf="canUseStreaming == 1" class="green">check</mat-icon>
  <mat-icon *ngIf="canUseStreaming == 2" class="red">close</mat-icon>
  <span>Livestream</span>
</div>

<div class="part-check">
  <mat-icon *ngIf="canUseWorkshop == 0">schedule</mat-icon>
  <mat-icon *ngIf="canUseWorkshop == 1" class="green">check</mat-icon>
  <mat-icon *ngIf="canUseWorkshop == 2" class="red">close</mat-icon>
  <span>Workshop</span>
</div>

<div class="part-check">
  <mat-icon *ngIf="canUseNetworking == 0">schedule</mat-icon>
  <mat-icon *ngIf="canUseNetworking == 1" class="green">check</mat-icon>
  <mat-icon *ngIf="canUseNetworking == 2" class="red">close</mat-icon>
  <span>Networking</span>
</div>

<div class="part-check">
  <mat-icon *ngIf="canUseBrowser == 0">schedule</mat-icon>
  <mat-icon *ngIf="canUseBrowser == 1" class="green">check</mat-icon>
  <mat-icon *ngIf="canUseBrowser == 2" class="red">close</mat-icon>
  <span>Browser</span>
</div>

<span class="underline" *ngIf="displayDetails">Details</span>

<div *ngIf="displayDetails" class="part-check">
  <span>Browser Version</span>
  <span class="infos">{{ browserversion }}</span>
</div>
<div *ngIf="hasProblems">
  <span class="underline">Troubleshooting</span>
  <div class="invalid" [innerHtml]="errormessage"></div>
  <div *ngIf="canUseWorkshop == 2">
    <button class="close" mat-raised-button (click)="bbbTrouble()">Erweiterten Test // Extended Check Workshop Rooms</button>
  </div>
</div>

<div class="extendedTest" *ngIf="!isLoading">
  <span class="underline">
    Lernen Sie die Platform Module kennen // Get accustomed to the platforms feature
  </span>
  <button mat-raised-button (click)="extendedCheck(0)">
    Test Workshop Rooms
  </button>
  <button mat-raised-button (click)="extendedCheck(1)">Test Livestream</button>
</div>

<button class="close" *ngIf="isDialog" mat-raised-button mat-dialog-close>Schließen // Exit</button>
